import { useState } from 'react';
import { IntlProvider } from 'react-intl';
import { Flex, Image, Layout, Select } from 'antd';

import LOCALES from '../i18n/locales.js';
import messages from '../i18n/messages.js';

import InfoBlock from './info-block/info-block.jsx';

import { flattenMessages } from '../utils/i18n/flatten-messages.js';

import './App.css';

const { Content, Footer, Header } = Layout;

const App = () => {
  const [currentLocale, setCurrentLocale] = useState(
    localStorage.getItem('locale') || LOCALES.ENGLISH,
  );

  const handleLanguageChange = (value) => {
    setCurrentLocale(value);
    localStorage.setItem('locale', value);
  };

  return (
    <IntlProvider
      messages={flattenMessages(messages[currentLocale])}
      locale={currentLocale}
      defaultLocale={LOCALES.ENGLISH}
    >
      <Layout className="layout">
        <Header className="header">
          <Flex justify="space-between" align="center">
            <Image src='/Vipn.svg' preview={false} width={56} height={70}/>
            <Select
              defaultValue={currentLocale}
              style={{ width: 120 }}
              onChange={handleLanguageChange}
              options={[
                { value: LOCALES.ENGLISH, label: 'English' },
                { value: LOCALES.RUSSIAN, label: 'Русский' },
              ]}
            />
          </Flex>
        </Header>
        <Content className="content">
          <InfoBlock keys={Object.keys(messages[currentLocale].requisites)} />
        </Content>
        <Footer className="footer">© Copyright 2025</Footer>
      </Layout>
    </IntlProvider>
  );
};

export default App;
